export default __webpack_public_path__ + "static/media/ios_step1.22e7db72.png";